import { Fragment, useEffect, useState } from "react";

import { CumulativeNew, RateNew, createDepsList, ControlPanel, castToCumulativePlot, castToRatePlot } from "../common/MetricPlots";
import { projectTotal, createDateBinning } from "../../services/baseplateService";

export const ShipmentGraphs = () => {
  // Form for toggling the display
  const [stacked, setStacked] = useState(true);
  const [timeAll, setTimeAll] = useState(false);
  const [countAll, setCountAll] = useState(false);
  const [mod, setMod] = useState(0);
  const [target, setTarget] = useState(0);

  const selectDisplay = {
    "CuW HD Full": { state: useState(true), types: ["FHW"], target: projectTotal("FHW") },
    "CuW LD Full": { state: useState(true), types: ["FLW"], target: projectTotal("FLW") },
    "CuW LD Left": { state: useState(true), types: ["LLW"], target: projectTotal("LLW") },
    "CuW LD Right": { state: useState(true), types: ["RLW"], target: projectTotal("RLW") },
    "CuW LD Top": { state: useState(true), types: ["TLW"], target: projectTotal("TLW") },
    "CuW LD Bottom": { state: useState(true), types: ["BLW"], target: projectTotal("BLW") },
    "CuW LD Five": { state: useState(true), types: ["5LW"], target: projectTotal("5LW") },
    "CuW HD Left": { state: useState(true), types: ["LHW"], target: projectTotal("LHW") },
    "CuW HD Right": { state: useState(true), types: ["RHW"], target: projectTotal("RHW") },
    "CuW HD Bottom": { state: useState(true), types: ["BHW"], target: projectTotal("BHW") },
    "Ti HD Full": { state: useState(true), types: ["FHT"], target: projectTotal("FHT") },
    "Ti LD Full": { state: useState(true), types: ["FLT"], target: projectTotal("FLT") },
    "Ti LD Left": { state: useState(true), types: ["LLT"], target: projectTotal("LLT") },
    "Ti LD Right": { state: useState(true), types: ["RLT"], target: projectTotal("RLT") },
    "Ti LD Top": { state: useState(true), types: ["TLT"], target: projectTotal("TLT") },
    "Ti LD Bottom": { state: useState(true), types: ["BLT"], target: projectTotal("BLT") },
    "Ti LD Five": { state: useState(true), types: ["5LT"], target: projectTotal("5LT") },
    "Ti HD Top": { state: useState(true), types: ["THT"], target: projectTotal("THT") },
  }

  const shipmentDisplay = {
    "unknown": { name: "unknown", color: "#AAA", state: useState(true) },
    "TIFR": { name: "TIFR", color: "#09988B", state: useState(true) },
    "IHEP": { name: "IHEP", color: "#5376BD", state: useState(true) },
    "NTU": { name: "NTU", color: "#8C682D", state: useState(true) },
    "CMU": { name: "CMU", color: "#A4161C", state: useState(true) },
    "UCSB": { name: "UCSB", color: "#00549D", state: useState(true) },
    "TTU": { name: "TTU", color: "#DE1818", state: useState(true) },
  }

  const [dataSum, setDataSum] = useState([]);
  const [dataRate, setDataRate] = useState([]);

  useEffect(() => {
    const allowedTypes = [];
    let tar = 0;
    Object.values(selectDisplay).forEach((value) => {
      if (value.state[0]) {
        value.types.forEach((x) => allowedTypes.push(x));
        tar += Number(value.target);
      }
    })
    setTarget(tar);
    setMod(mod + 1);
    createDateBinning(allowedTypes, "ship_date", "destination", "day").then((data) => {
      setDataSum(castToCumulativePlot(data));
    });
    createDateBinning(allowedTypes, "ship_date", "destination", "week").then((data) => {
      setDataRate(castToRatePlot(data));
    });
    // eslint-disable-next-line
  }, createDepsList(selectDisplay));

  return <Fragment>
    <ControlPanel
      stackState={[stacked, setStacked]}
      timeZoom={[timeAll, setTimeAll]}
      countZoom={[countAll, setCountAll]}
      setMod={setMod}
      selectDisplay={selectDisplay}
      catDisplay={shipmentDisplay}
    />
    <hr />
    <CumulativeNew
      showStacked={stacked}
      timeZoom={timeAll}
      countZoom={countAll}
      keyState={[mod, setMod]}
      dataTable={dataSum}
      target={target}
      catDisplay={shipmentDisplay}
      downloadPrefix="shipment" />
    <hr />
    <RateNew
      showStacked={stacked}
      timeZoom={timeAll}
      keyState={[mod, setMod]}
      dataTable={dataRate}
      catDisplay={shipmentDisplay}
      downloadPrefix="shipment" />
  </Fragment >
}

export default ShipmentGraphs;


